<script lang="ts">
	// Genuine shadcn-svelte Select.Item (bits-ui), RESTYLED to price-check tokens.
	// The selected-row check uses lucide-core via our Icon wrapper. NO arbitrary
	// `[..]` values.
	import { Select as SelectPrimitive } from "bits-ui";
	import { cn, type WithoutChild } from "../../../utils.js";
	import { Check } from "lucide";
	import Icon from "../../../icon.svelte";

	let {
		ref = $bindable(null),
		class: className,
		value,
		label,
		children: childrenProp,
		...restProps
	}: WithoutChild<SelectPrimitive.ItemProps> = $props();
</script>

<SelectPrimitive.Item
	bind:ref
	{value}
	data-slot="select-item"
	class={cn(
		"relative flex w-full cursor-default items-center gap-1.5 rounded-md py-1.5 pr-8 pl-2 text-sm text-ink outline-none select-none data-highlighted:bg-surface-muted data-highlighted:text-ink data-[disabled]:pointer-events-none data-[disabled]:opacity-55 [&_svg]:pointer-events-none [&_svg]:shrink-0",
		className
	)}
	{...restProps}
>
	{#snippet children({ selected, highlighted })}
		<span class="absolute end-2 flex size-3.5 items-center justify-center">
			{#if selected}
				<Icon icon={Check} size={14} class="text-brand" />
			{/if}
		</span>
		{#if childrenProp}
			{@render childrenProp({ selected, highlighted })}
		{:else}
			{label || value}
		{/if}
	{/snippet}
</SelectPrimitive.Item>
